const disable_broadcast = window.sessionStorage.getItem('disable_broadcast');
const channel = !disable_broadcast ? new BroadcastChannel('checkbus-v2') : null;
export default channel;
